import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { IStateService } from 'angular-ui-router';
import { Observable } from 'rxjs/Observable';
import { IFlag } from 'Src/ng2/shared/typings/interfaces/flags.interface';
import { ISchool } from 'Src/ng2/shared/typings/interfaces/school.interface';
import { IStudent } from './../../../store/reducers/student-reducer';

@Component({
  selector: 'graph-detail-content',
  template: require('./graph-detail-content.component.html'),
  styles: [require('./graph-detail-content.scss')],
})
export class GraphDetailContentComponent {
  @Input() graphData: { key: string };
  @Input() groupings$;
  @Input() students$: Observable<IStudent>;
  @Input() flags$: Observable<IFlag>;
  @Input() isCalculatedState: boolean;
  @Input() school: ISchool;

  @Output() sortData: EventEmitter<any> = new EventEmitter();

  constructor(@Inject('$state') private $state: IStateService) {}

  goToState(state: string) {
    this.$state.go(state, { graphName: this.graphData.key }, { location: 'replace' });
  }

  runSortData($event: { key: string; dataType: string; orderBy: string }) {
    this.sortData.emit($event);
  }
}
